import { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { useParams } from "react-router";
import { SectionTitle, CmpTable, Loader } from "../shared";
import { GET_COUNTRY_SPECIALTY_LIST, GET_ALL_SPECIALTY } from "./query";
import SubComponent from "./SubComponent";
import { COUNTRY_LIST } from "../../utils";
import { useDispatch } from "react-redux";
import { setSpecialtyOptions } from "../../reducers/specialty";

const GroupSpecialtyList = () => {
    const dispatch = useDispatch();
    const [specialityFilter, setSpecialityFilter] = useState([]);
    const { country } = useParams();

    const [getSpecialtyFilter, { data, loading }] = useLazyQuery(gql(GET_COUNTRY_SPECIALTY_LIST), {
        variables: { filter: { country: { equalTo: country } } },
    });

    const columns = [
        {
            header: "Specialty Id",
            accessorKey: "specialtyId",
        },
        {
            header: "Specialty Name",
            accessorKey: "specialtyName",
        },
        {
            header: "Group Specialty Name",
            accessorKey: "abbvieProGroupSpecialtyByGroupId",
            cell: (cell) => cell.getValue().groupSpecialtyName,
        },
    ];

    const renderSubComponent = (data) => {
        return <SubComponent data={data.row.original} />;
    };

    useEffect(() => {
        getSpecialtyFilter();

        if (data && data.allAbbvieProGroupSpecialties && data.allAbbvieProGroupSpecialties.nodes) {
            const nodes = data.allAbbvieProGroupSpecialties.nodes;
            const idArray = nodes.map((node) => node.id);
            setSpecialityFilter(idArray);
            const options = nodes.map((node) => {
                return { id: node.id, name: node.name };
            });

            dispatch(setSpecialtyOptions(options));
        }
    }, [data]);

    return (
        <>
            {loading && <Loader />}
            <SectionTitle
                title={`${COUNTRY_LIST[country]}: Specialty List`}
                buttonUrl={`/abbvie-pro/group-specialties/${country}/create`}
                backUrl="/abbvie-pro/group-specialties"
            />

            {specialityFilter && specialityFilter.length > 0 ? (
                <CmpTable
                    QUERY={GET_ALL_SPECIALTY}
                    getRowCanExpand={() => true}
                    headers={columns}
                    renderSubComponent={renderSubComponent}
                    dataPath="allAbbvieProSpecialtyMaps"
                    variables={{ filter: { groupId: { in: specialityFilter } } }}
                />
            ) : (
                !loading && (
                    <div className="card">
                        <div className="card-body">
                            <p className="text-danger mb-0">No data found</p>
                        </div>
                    </div>
                )
            )}
        </>
    );
};

export default GroupSpecialtyList;
